module.exports = __webpack_public_path__ + "static/datareporting-5483706a34f0e1bffdb82bc025473301.jpeg";